import React, { useState } from 'react';
import { urls } from '..';
import { byDesc } from '../data/utils/byDesc';
import { getConfiguration } from '../data/utils/configuration';
import HighlightedTournaments from '../prematch/HighlightedTournaments';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import CategoryCheckbox from './CategoryCheckbox';
import FavoriteButton from './FavoriteButton';
import { useIsDateSection } from './IsDateSectionProvider';
import OpenSelectionsButton from './OpenSelectionsButton';
import TournamentCheckbox from './TournamentCheckbox';
import TournamentsSelectionsProvider from './TournamentsSelectionsProvider';
import { useUserSettings } from './UserSettingsProvider';
import XRouterLink from './seo/xrouter/XRouterLink';
import useIsLiveSection from './useIsLiveSection';
import TournamentLiveBadge from '../prematch/TournamentLiveBadge';
import CategoryLiveBadge from '../prematch/CategoryLiveBadge';
import PopularTournaments from './PopularTournaments';
import { getLabel } from '../data/labels';

export function Tournament(props) {
    const prematchData = usePrematchData();
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();

    const t = props.data;
    const category = prematchData.sportById[t.sportRef].categoryById[t.categoryRef];
    const id = isDateSection ? t.id : t.uniqueId;

    function getUrl() {
        let url, isrelative = false;
        if (isLiveSection) {
            url = `${urls.base}/${urls.live.base}/${urls.live.torneo}/${id}`;
        } else if (isDateSection) {
            url = `${id}`;
            isrelative = true;
        } else {
            url = `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${id}`;
        }

        return [url, isrelative]
    }

    /*function openTournament(e) {
        e.stopPropagation();
        navigate(getUrl());
    }*/

    const [url, isrelative] = getUrl();
    const conf = getConfiguration();

    return (
        <>
            <div className="xs_tournamentItem h-[50px] grid grid-cols-10 items-center bg-cs1 border-b border-b-cs7">
                <FavoriteButton id={t.uniqueId || t.id} />
                {props.showCategory ?
                    <XRouterLink isrelative={isrelative} data={t} to={url} className="col-start-2 col-end-9 px-1 grid grid-rows-2" >
                        <span className="font-bold text-xs text-cs9 uppercase truncate">{category?.descrizione ?? ''}</span>
                        <div className="flex items-center truncate">
                            <span className="font-bold text-sm text-cs10 truncate">{t.descrizione || t.desc}</span>
                            <TournamentLiveBadge uniqueId={t.uniqueId} />
                        </div>
                    </XRouterLink>
                    :
                    <XRouterLink isrelative={isrelative} data={t} to={url} className="col-start-2 col-end-9 px-1" >
                        <div className="flex items-center truncate">
                            <span className="font-bold text-sm text-cs10 truncate">{t.descrizione || t.desc}</span>
                            <TournamentLiveBadge uniqueId={t.uniqueId} />
                        </div>
                    </XRouterLink>
                }
                {/* <div className="col-start-7 col-end-9 flex items-center justify-center">
                    {t.classifica &&
                        <RankingsButton classifica={t.classifica} sportId={t.sportRef} />
                    }
                </div> */}
                <div className="col-start-9 col-end-10 flex items-center justify-center">
                    {props.showCheckbox &&
                        <TournamentCheckbox id={id} />
                    }
                </div>
                <div className="col-start-10 col-end-11 flex items-center justify-center">
                    <div className="min-h-[20px] min-w-[28px] w-fit px-1 flex items-center justify-center bg-cs4 rounded-md">
                        {conf.iwh ? (
                            <span className="leading-[.6rem] font-medium text-xxs text-cs1">
                                ({t.eventsCount ? t.eventsCount : t.matches.length})
                            </span>
                        ) : (
                            <span className="leading-[.6rem] font-medium text-xxs text-cs1">
                                {t.eventsCount ? t.eventsCount : t.matches.length}
                            </span>
                        )}


                    </div>
                </div>
            </div>
        </>
    );
}

function CategoryDropdown(props) {
    const isDateSection = useIsDateSection();
    const [toggled, setToggled] = useState(props.startToggled);

    function toggle() {
        setToggled(!toggled);
    }

    const c = props.data;

    return (
        <>
            <div className="xs_categoryHeader grid grid-cols-10 py-1 bg-cs7 text-cs6 border border-b border-b-cs16" onClick={toggle}>
                {c.categoryIcon ?
                    <>
                        <div className={"col-start-1 col-end-2 justify-self-center inline-block border border-cs7 w-[16px] h-[16px] " + c?.categoryIcon ?? ''}></div>
                        <div className="col-start-2 col-end-9 pl-2 flex items-center">
                            <span className="font-medium text-xs uppercase mr-auto">{c.descrizione}</span>
                            <CategoryLiveBadge uniqueId={c.uniqueId} />
                        </div>
                    </>
                    :
                    <div className="col-start-1 col-end-9 pl-2 flex items-center">
                        <span className="font-medium text-xs uppercase mr-auto">{c.descrizione}</span>
                        <CategoryLiveBadge uniqueId={c.uniqueId} />
                    </div>
                }
                <div className="col-start-9 col-end-10 flex items-center justify-center">
                    <CategoryCheckbox tournaments={c.tournaments} useUniqueId={!isDateSection} />
                </div>
                <div className="col-start-10 col-end-11 flex items-center justify-center">
                    {toggled ?
                        <i className="bi bi-chevron-up"></i>
                        :
                        <i className="bi bi-chevron-down"></i>
                    }
                </div>
            </div>
            {toggled && props.children}
        </>
    );
}
export default function TournamentsMenuDropdown(props) {
    const userSettings = useUserSettings();
    const conf = getConfiguration();
    const [competitionsOpen, setCompetitionsOpen] = useState(true);

    let categories = props.categories;

    if (userSettings.sortCategoriesByDesc) {
        categories = Array.from(props.categories).sort(byDesc);
    }

    const categoriesList = categories.map(c => (
        <CategoryDropdown key={c.id} data={c}>
            {c.tournaments.map(t =>
                <Tournament key={t.uniqueId} data={t} showCheckbox={true} />
            )}
        </CategoryDropdown>
    ));

    return (
        <TournamentsSelectionsProvider>
            {userSettings.showHighlightedTournaments &&
                <HighlightedTournaments sportId={categories[0].sportRef} categories={props.categories} />
            }
            {conf.spt &&
                <PopularTournaments sportId={categories[0].sportRef} />
            }
            {conf.spt ? (
                <>
                    <div
                        className="xs_categoryHeader grid grid-cols-10 py-1 bg-cs7 text-cs6 border border-b border-b-cs16"
                        onClick={() => setCompetitionsOpen(!competitionsOpen)}
                    >
                        <div className="col-start-1 col-end-9 pl-2 flex items-center">
                            <span className="font-medium text-xs uppercase mr-auto">
                                {getLabel('all_competitions', 'Tutte le competizioni')}
                            </span>
                        </div>
                        <div className="col-start-10 col-end-11 flex items-center justify-center">
                            <i className={competitionsOpen ? 'bi bi-chevron-up' : 'bi bi-chevron-down'}></i>
                        </div>
                    </div>
                    {competitionsOpen && categoriesList}
                </>
            ) : (
                categoriesList
            )}
            <OpenSelectionsButton />
        </TournamentsSelectionsProvider>
    );
}